import React, { useState } from "react";
import {
  validateOtp,
  resendConfirmationCode,
  handleConfirmSignUp,
  handleLogin,
  sendPassword,
  verifyCurrentUserAttributeSubmitPool,
  getCurrentAuthenticatedUser,
  verifyCurrentUserAttributePool,
} from "../../helper";
import EnterOTP from "../OTP/otp";
import New from "./new";
import strings from "../../constants/strings";
import "./styles.scss";

export default function SignUp(props) {
  let {
    closeSignupModal,
    getLoggedInDetails,
    setShowOTP,
    resendSignupVerification,
    showAlert,
    openLoginModal,
    username,
    email,
    given_name,
    handleFormInputChange,
    completeSocialSignup,
    setCompleteSocialSignup,
    verifyPhoneNumber,
    setVerifyPhoneNumber,
    isMobile,
  } = props;
  const [otp, setOtp] = useState(null);

  const [currentForm, setCurrentForm] = useState(
    resendSignupVerification || verifyPhoneNumber ? "otp" : "details"
  );
  return {
    details: (
      <New
        given_name={given_name}
        username={username}
        email={email}
        handleFormInputChange={handleFormInputChange}
        setCurrentForm={setCurrentForm}
        closeSignupModal={closeSignupModal}
        showAlert={showAlert}
        handleFormChange={setCurrentForm}
        openLoginModal={openLoginModal}
        completeSocialSignup={completeSocialSignup}
        setVerifyPhoneNumber={setVerifyPhoneNumber}
        isMobile={isMobile}
      />
    ),
    otp: (
      <EnterOTP
        otp={otp}
        handleChange={(value) => setOtp(value)}
        handleNext={async () => {
          if (validateOtp(otp)) {
            verifyPhoneNumber
              ? await verifyCurrentUserAttributeSubmitPool("phone_number", otp)
                  .then(() => showAlert("SignUp", "SignUp confirmed!", true))
                  .then(() => {
                    completeSocialSignup && setCompleteSocialSignup(false);
                    verifyPhoneNumber && setVerifyPhoneNumber(false);
                    closeSignupModal();
                  })
                  .then(
                    async () =>
                      await getCurrentAuthenticatedUser(true)
                        .then((user) => user)
                        .then((user) => user && getLoggedInDetails(user))
                        .catch((error) => console.log(error))
                  )
                  .catch((error) => console.log(error))
              : await handleConfirmSignUp(username, otp)
                  .then(async (result) => {
                    if (result) {
                      !resendSignupVerification
                        ? await handleLogin(
                            username,
                            given_name.toUpperCase().substring(0, 4) +
                              String(username).substring(
                                String(username).length - 4
                              )
                          )
                            .then((user) => getLoggedInDetails(user))
                            .then(() =>
                              showAlert("SignUp", "SignUp confirmed!", true)
                            )
                            .catch((error) =>
                              showAlert(
                                "SignUp",
                                `${error.message}. Unable to Login. Please try logging in.`
                              )
                            )
                        : showAlert(
                            "SignUp",
                            "Signup confirmed! Please login",
                            true
                          );
                      sendPassword(email, given_name, username);
                      closeSignupModal();
                      setShowOTP(false);
                    }
                  })
                  .catch((error) =>
                    showAlert(
                      "SignUp",
                      `${error.message}. Unable to signup. Please try again.`
                    )
                  );
            verifyPhoneNumber && setVerifyPhoneNumber(false);
          } else {
            showAlert("SignUp", "Invalid OTP");
          }
        }}
        handleResendConfirmationCode={() =>
          verifyPhoneNumber && completeSocialSignup
            ? verifyCurrentUserAttributePool("phone_number")
                .then(() =>
                  showAlert(
                    "Complete Social Signup",
                    "OTP has been resend successfully.",
                    true
                  )
                )
                .catch((error) =>
                  showAlert("Complete Social Signup", error.message)
                )
            : resendConfirmationCode(username)
                .then(() =>
                  showAlert("SignUp", "OTP re-sent successfully", true)
                )
                .catch((error) =>
                  showAlert(
                    "SignUp",
                    `${error.message}. Unable to re-send OTP. Please try again.`
                  )
                )
        }
        buttonText={strings.SIGNUP}
      />
    ),
  }[currentForm];
}
